import React from 'react';
import { NavLink } from 'react-router-dom';

export default function BankAccountDetails() {
	return (
		<div className="px-1 2xl:px-10 pt-20 lg:pt-10">
			<h1 className="mb-10">Bank Account Details</h1>
			<div className="w-full h-[1px] bg-gray-400" />
			<div className="flex-1 lg:flex lg:flex-row pb-20 overflow-scroll">
				<div className="lg:basis-4/5 w-full">
					<div className="mt-10">
						<h2 className="mb-2" id="settlements">
							Settlements
						</h2>
						<p className="">
							Settlement is a process whereby money collected on your behalf is
							delivered to your Primary Bank Account or other listed account in
							case of split payment.
						</p>
						<p className="mt-2">
							Once you receive payments into your SPay account, your funds are
							automatically settled to you primary account the next business
							days (T+1 ). You can also settle your funds to other registered
							bank account other than the primary bank account in case of split
							payment
						</p>
					</div>
					<div>
						<h2 className="mb-2 mt-5" id="why-settlement-are-flagged">
							Why Settlements are flagged
						</h2>
						<p className="">
							Flagged settlements are settlements that don’t meet disbursement
							requirements and are therefore withheld. Settlements can be
							flagged for a good number of reasons. Here are the most common
							causes of flagged settlements:
						</p>
						<div className="mt-2 ml-5">
							<ol className="">
								<li className="text-sm">1. Incomplete KYC Verification.</li>
								<li className="text-sm">2. Temporary lien on your account.</li>
								<li className="text-sm">3. No settlement account.</li>
								<li className="text-sm">4. Negative settlement amount.</li>
								<li className="text-sm">5. Settlements below the threshold.</li>
							</ol>
						</div>
					</div>
					<div>
						<h2 className="mb-2 mt-5" id="add-account">
							Add Account
						</h2>
						<p className="">
							Account can either be primary or non primary. Primary account is
							the default settlement account and all money collected on your
							behalf will be settled into this account unless in the case where
							split is specified in the payment request.
						</p>
						<p className="mt-2">
							When split is specified in the payment request the split amount
							will be settled into the split settlement account specified int
							the request; it could be primary account or non-primary account.
						</p>
						<p className="mt-2">
							You can only have one primary account and all other account will
							be non-primary.
						</p>
						<div className="mt-2 ml-5">
							<ol>
								<li className="text-sm">1. Business Name</li>
								<li className="text-sm">2. Business Email Address</li>
								<li className="text-sm">3. Country</li>
								<li className="text-sm">
									4. Password (password must be at least 8 characters long and
									contain at least one special character.)
								</li>
								<li className="text-sm">5. Business Category</li>
								<li className="text-sm">6. Business Type</li>
								<li className="text-sm">7. About Business - Optional</li>
							</ol>
						</div>
						<p className="mt-2">
							Immediately after you&apos;ve created an account, you will be
							prompted to create a business. To do so, follow the steps below:
						</p>
						<p className="">
							Enter your company name and choose your business category. If you
							are a registered business, ensure that your business name is
							identical with the name in your registration documents.​
						</p>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require('../../assets/Image/BAD1.png')}
								alt="MerchantReg"
								className="w-full mt-5 mb-2"
								width={800}
								height={400}
							/>
							<p className="text-center mb-8">Create Non-Primary Account</p>
						</div>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require('../../assets/Image/BAD2.png')}
								alt="MerchantReg"
								className="w-full mt-5 mb-2"
								width={800}
								height={600}
							/>
							<p className="text-center mb-8">Create Primary Account</p>
						</div>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require('../../assets/Image/BAD3.png')}
								alt="MerchantReg"
								className="w-100 mt-5 mb-2"
								width={800}
								height={400}
							/>
							<p className="text-center mb-8">Settlement Accounts</p>
						</div>
					</div>
					<div className="border-t-2 flex flex-row justify-between ">
						<div className="mt-5">
							<NavLink to="/accept-payments">
								<p className="">Accept Payments Kyc →</p>
							</NavLink>
						</div>
					</div>
				</div>
				<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
					<div className="lg:w-40 2xl:w-52 lg:fixed lg:top-52 lg:right-1 xl:right-4 2xl:right-10">
						<div className="mb-2">
							<h3 className="">Table of Contents</h3>
						</div>
						<div className="ml-2 selection:lg:ml-5">
							<a href="#settlements">
								<p className="text-sm text-[#637288] mb-1">Settlements</p>
							</a>
							<a href="#why-settlement-are-flagged">
								<p className="text-sm text-[#637288] mb-1">
									Why Settlements are flagged
								</p>
							</a>
							<a href="#add-account">
								<p className="text-sm text-[#637288]">Add Account</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
